import { SidebarMenu } from '.';

export const Sidebar = () => {
  return (
    <aside className="app-sidebar column is-2 is-justify-content-center  p-3">
      <SidebarMenu />
    </aside>
  );
};
